import type { LocaleCode } from '@/pages/cogo-marketing/i18n/locales'

export interface DesignSystemPreviewCopy {
  loading: string
  waiting: string
  error: string
  catalogRejected: string
  ontologyRejected: string
  timeout: string
  retry: string
}

const COPY: Record<LocaleCode, DesignSystemPreviewCopy> = {
  en: {
    loading: 'Loading preview components…',
    waiting: 'Preparing the live preview…',
    error: 'The design preview could not be loaded.',
    catalogRejected: 'UI Block is not admitted by the Studio catalog: {ref}',
    ontologyRejected: 'UI Block preview design authority is unresolved: {roles}',
    timeout: 'The design preview did not become ready in time.',
    retry: 'Retry preview',
  },
  ko: {
    loading: '미리보기 컴포넌트를 불러오는 중…',
    waiting: '실시간 미리보기를 준비하는 중…',
    error: '디자인 미리보기를 불러오지 못했습니다.',
    catalogRejected: 'UI Block이 Studio 카탈로그에 승인되지 않았습니다: {ref}',
    ontologyRejected: 'UI Block 미리보기의 디자인 권한을 확인할 수 없습니다: {roles}',
    timeout: '디자인 미리보기가 제한 시간 안에 준비되지 않았습니다.',
    retry: '미리보기 다시 시도',
  },
  ja: {
    loading: 'プレビューコンポーネントを読み込み中…',
    waiting: 'ライブプレビューを準備中…',
    error: 'デザインプレビューを読み込めませんでした。',
    catalogRejected: 'UI Block は Studio カタログに承認されていません: {ref}',
    ontologyRejected: 'UI Block プレビューのデザイン権限を解決できません: {roles}',
    timeout: 'デザインプレビューの準備が時間内に完了しませんでした。',
    retry: 'プレビューを再試行',
  },
  zh: {
    loading: '正在加载预览组件…',
    waiting: '正在准备实时预览…',
    error: '无法加载设计预览。',
    catalogRejected: 'UI Block 未获 Studio 目录准入: {ref}',
    ontologyRejected: '无法解析 UI Block 预览的设计权限: {roles}',
    timeout: '设计预览未能在规定时间内准备就绪。',
    retry: '重试预览',
  },
  'zh-TW': {
    loading: '正在載入預覽元件…',
    waiting: '正在準備即時預覽…',
    error: '無法載入設計預覽。',
    catalogRejected: 'UI Block 未獲 Studio 目錄准入: {ref}',
    ontologyRejected: '無法解析 UI Block 預覽的設計權限: {roles}',
    timeout: '設計預覽未能在時間內準備完成。',
    retry: '重試預覽',
  },
}

export function getDesignSystemPreviewCopy(
  locale: LocaleCode,
): DesignSystemPreviewCopy {
  return COPY[locale]
}
